export const contactInfo = {
  email: 'info@sparklean.sk',
  phone: '+421 951 995 320'
};

export default contactInfo;
